/**
 * Module Dependencies
 */

import './index.css'
import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

/**
 * Export the `Fin` logo and text
 */

export default function FinLogo ({ message, animate, white }) {
  return (
    <div className='fin-logo-wrapper'>
      <div className='hero'>
        <div className={ classnames('graphic fin', { 'animated bounce infinite': animate, white }) } />
        <span className='title'>finbox</span>
      </div>
      { message && <h5 className='message'>{ message }</h5> }
    </div>
  )
}

FinLogo.defaultProps = {
  animate: true,
  message: 'Loading...'
}

FinLogo.propTypes = {
  white: PropTypes.bool,
  animate: PropTypes.bool.isRequired,
  message: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool
  ]).isRequired
}
